import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import Link from "../Link";

var SelectedItem = function SelectedItem(_ref) {
  var children = _ref.children,
      href = _ref.href;
  var getClassName = getClassNameFactory("SearchFiltersSelectedItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Link, null, children)), /*#__PURE__*/React.createElement("a", {
    href: href,
    className: getClassName({
      descendantName: "remove"
    })
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    label: "Remove filter"
  })));
};

SelectedItem.displayName = "SearchFilters.SelectedItem";
export default SelectedItem;